var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#528AEA",
    fillRule: "evenodd",
    d: "M16.442 13.718l-2.583-2.584c-.515-.512-1.367-.496-1.899.036l-1.301 1.301a38.067 38.067 0 0 1-.257-.143c-.822-.455-1.946-1.079-3.13-2.263C6.085 8.878 5.46 7.75 5.004 6.929l-.14-.25.873-.873.43-.43c.533-.533.547-1.385.034-1.899L3.618.894C3.105.38 2.253.396 1.72.929l-.728.733.02.02a4.21 4.21 0 0 0-.6 1.057c-.14.37-.227.721-.266 1.074-.342 2.827.95 5.411 4.457 8.918 4.847 4.846 8.753 4.48 8.922 4.462a4.364 4.364 0 0 0 1.076-.27c.384-.15.743-.354 1.054-.597l.016.014.737-.722c.533-.534.548-1.386.035-1.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.bf876ee0f512f2bc768389489267b171.svg";
export { ForwardRef as ReactComponent };